import { render, staticRenderFns } from "./S13.vue?vue&type=template&id=2a00347c&scoped=true&"
import script from "./S13.vue?vue&type=script&lang=js&"
export * from "./S13.vue?vue&type=script&lang=js&"
import style0 from "./S13.vue?vue&type=style&index=0&id=2a00347c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00347c",
  null
  
)

export default component.exports